// @flow
import React from 'react';
import { HTMLView } from 'components/atoms/htmlView';
import { useViewport } from 'components/templates/viewportProvider';
import type { Contact } from 'types/common';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  contact: Contact,
  type?: string,
};

export const ContactDetails = (props: Props) => {
  const { isMobile } = useViewport();
  let { contact, type } = props;
  if (!contact) {
    return null;
  }

  const title = isMobile ? 'Contact Us' : contact.title;
  const reservationTitle = isMobile
    ? 'Reserve your unique dining experience'
    : contact.title;

  const contactText = type === 'reservation' ? 'Contact' : 'Sales';

  return (
    <div className={'contact-details'}>
      <div>
        {isMobile ? (
          <h2>{type === 'reservation' ? reservationTitle : title}</h2>
        ) : (
          <h1>{title}</h1>
        )}
        <HTMLView
          tagName={'div'}
          html={ type === 'reservation'
              ? contact.reservationFormDescription
              : contact.description
          }
          className={'description'}
        />
      </div>
      {type !== 'reservation' && (
        <div>
          <HTMLView
            tagName={'div'}
            html={contact.address}
            className={'address'}
          />
        </div>
      )}
      <div className={'sales'}>
        {isMobile ? <h4>{contactText}</h4> : <h3>{contactText}</h3>}
        <div>
          <div className={'contact-information'}>
            {!isMobile && (
              <span className={'contact-type'}>
                {type === 'reservation' ? 'Phone:' : 'Mobile'}
              </span>
            )}
            {isMobile ? (
              <a href={`tel:${contact.phone}`} data-rel={'external'}>
                <p>{contact.phone}</p>
              </a>
            ) : (
              <p>{contact.phone}</p>
            )}
          </div>
          <div className={'contact-information'}>
            {!isMobile && (
              <>
                <span className={'contact-type'}>
                  {type === 'reservation' ? 'Email:' : 'Email'}
                </span>
              </>
            )}
            <a href={`mailto:${contact.email}`} data-rel={'external'}>
              <p className={'email-hovered'}>{contact.email}</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
